import React from 'react';
import LazyImage from '../../components/CustomLibraries/LazyImage';
import '../share/css/share.scss';
import { isMobile } from 'react-device-detect';

function ShareHeaderNew({ loginPage }) {
  return (
    <div
      className={`d-md-flex d-block justify-content-between align-items-center text-center text-md-start  ${
        isMobile
          ? 'loginLogoCard bg-white mt-0 mb-0 rounded py-20 px-4 shadow mb-md-3 mt-md-0'
          : 'mb-5 mt-3'
      } `}
    >
      <span className="d-md-flex d-block flex-row align-items-center mb-md-0 mb-3">
        <img
          src="https://img-cdn.clirnet.com/medwiki/images/clirnet_logo.jpg"
          alt="Clirnet"
          className="mb-3 mb-md-0 me-md-4 me-0"
          extraClass={''}
        />
        <strong className="fw-bold fs-36 text-black d-block">Explore CLIRNET</strong>
      </span>

      <h1 className="fw-medium text-black fs-2">World's Fastest Growing Community of Doctors</h1>
    </div>
  );
}

export default ShareHeaderNew;

//loginLogoCard for login page
